<i18n>
  {
    "pt_BR": {
      "date": "Criada em {0}",
      "copy": "Copiar URL",
      "copied": "URL copiada!",
      "sends": "Envios de SMS",
      "inbound": "Retorno SMS",
      "last": "Última mensagem enviada",
      "empty": {
        "text": "Sala vazia. 👀",
        "what": "Essa é a sala onde suas campanhas SMS aparecerão. Ela está vazia porque você ainda não criou uma campanha.",
        "ask": "Deseja começar?",
        "help": "A gente te ajuda.",
        "create": "Criar minha primeira campanha"
      }
    }
  }
</i18n>

<template>
  <section class="campaigns">
    <div class="campaign-list">

      <template v-if="! ready">
        Loading...
      </template>

      <template v-else-if="hasCampaign">
        <router-link class="campaign" :to="{ path: '/campaign/' + campaign.hash_id }" :key="campaign.id" v-for="campaign in list">
          <header class="campaign-header">
            <div class="campaign-header--info">
              <h3 class="campaign-header--title" v-text="campaign.title"></h3>
              <p class="campaign-header--date" v-text="$t('date', [campaign.created_at])"></p>
            </div>
            <div class="campaign-header--action">
              <copy :text="campaign.url">
                <button @click.prevent.stop slot-scope="{ copied }" class="campaign-header--copy-url btnCopyUrl" :class="{ active: copied }" v-t="copied ? 'copied' : 'copy'"></button>
              </copy>
            </div>
          </header>
          <div class="campaign-message">
            <p class="campaign-message--bubble" v-text="parse(campaign.body)"></p>
          </div>
          <footer class="campaign-footer">
            <div class="campaign-footer--col">
              <h5 class="campaign-footer--title" v-t="'sends'"></h5>
              <p class="campaign-footer--text" v-text="campaign.sms_count > 0 ? campaign.sms_count : '- - -'"></p>
            </div>
            <div class="campaign-footer--col">
              <h5 class="campaign-footer--title" v-t="'inbound'"></h5>
              <p class="campaign-footer--text" v-text="campaign.inbound_count > 0 ? campaign.inbound_count : '- - -'"></p>
            </div>
            <div class="campaign-footer--col">
              <h5 class="campaign-footer--title" v-t="'last'"></h5>
              <p class="campaign-footer--text" v-text="campaign.last != null ? campaign.last.created_at : '- - -'"></p>
            </div>
          </footer>
        </router-link>
      </template>

      <article class="no-campaign" v-else>
        <h2 class="no-campaign--title" v-t="'empty.text'"></h2>
        <p class="no-campaign--text" v-t="'empty.what'"></p>
        <p class="no-campaign--text">
          <span v-t="'empty.ask'"></span> {{ $t('empty.help') }}
        </p>

        <router-link class="no-campaign--new-campaign" :to="{ path: '/campaign/new' }" v-t="'empty.create'" />
      </article>
    </div>
  </section>
</template>

<script>
  import Copy from '@/Copy';
  import { mapGetters, mapState, mapActions } from 'vuex';

  export default {
    components: {
      Copy,
    },

    computed: {
      ...mapState('campaign', [
        'ready', 'list',
      ]),

      ...mapGetters('campaign', [
        'hasCampaign',
      ]),
    },

    created () {
      this.fetch();
    },

    methods: {
      parse (body) {
        return body.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      },

      ...mapActions('campaign', [
        'fetch',
      ]),
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Campaign/Campaign.vue